'use strict'

var Marionette = require('marionette')
var App = require('app')
var _ = require('lodash')
var MapModule = require('src/common/map')


/**
 * Layout
 * -----------------------------------------------------------------------------
 */
module.exports.Layout = Marionette.View.extend({
  template: require('./templates/layout.html'),
  modelEvents: {
    'change': 'render'
  },
  onDomRefresh: function () {
    var self = this
    // location
    var loc = [0, 0]
    if (self.model.attributes.geoLocation) {
      loc = self.model.attributes.geoLocation
    }

    // map
    var editMap = new MapModule({
      'container': 'situationMap',
      'location': loc,
      'zoomLevel': 20,
      'styleToggle': true      
    })

    var feature = {
      'properties': {
        'name': self.model.get('name'),
        'id': self.model.get('_id'),
        'type': self.model.get('type'),
        'online': self.model.get('online'),
        'error': self.model.get('error'),
        'model': self.model
      }}

    editMap.addMarker(loc, {
      mapBoxOptions: {
        draggable: false
      },
      onDragEnd: function (event) {
        var marker = event.target // you could also simply access the marker through the closure
        var result = marker.getLatLng() // but using the passed event is cleaner
        self.model.setLocation(result.lat, result.lng)
      },
      feature: feature
    })
  },
  templateContext: function () {
    let self = this;
    return {
      hasAssetData: function () {
    
        return self.options.assetData
      },
      getAssetData: function () {
        return self.options.assetData.attributes
      },
      getLastSeenAt: App.TemplateHelpers.getLastSeenAt,
      hasSensor: App.TemplateHelpers.hasSensor,
      getConditionalStr: App.TemplateHelpers.getConditionalStr,
      getSensorValue: App.TemplateHelpers.getSensorValue,
      getDeviceTypeLabel: App.TemplateHelpers.getDeviceTypeLabel
    }
  }
})



// WEBPACK FOOTER //
// ./js/modules/device-situation/show/view.js